import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { OrderSettlementState } from '@/types/types'
import useI18nTl from '@/hooks/useI18nTl'

import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'EvseOrderSettlementStatus',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  state: {
    type: Number,
  },
},
  setup(__props) {

const props = __props

const { tl } = useI18nTl('Order')



const statusLabel = computed(() => {
  switch (props.state) {
    case OrderSettlementState.OSS_INIT: //  准备结算
      return tl('settleStateInit')
    case OrderSettlementState.OSS_PROCESS: //  结算中
      return tl('settleStateProcess')
    case OrderSettlementState.OSS_ABNORMAL: //  结算未知异常
      return tl('settleStateAbnormal')
    case OrderSettlementState.OSS_ABNORMAL_EXCESS: //  结算异常状态，充超额了
      return tl('settleStateAbnormalExcess')
    case OrderSettlementState.OSS_ABNORMAL_BIZ_NON_FINISH_STATE: //  业务不是处于完成状态，无法结算
      return tl('settleStateAbnormalBizNonFinishState')
    case OrderSettlementState.OSS_ABNORMAL_WALLET_LACK_MONEY: //  钱包余额不足
      return tl('settleStateAbnormalWalletLackMoney')
    case OrderSettlementState.OSS_SUCCESS: //  业务正常完成
      return tl('settleStateSuccess')
  }
  return tl('waitingSettlement')
})

const statusTips = computed(() => {
  switch (props.state) {
    case OrderSettlementState.OSS_INIT: //  准备结算
      return tl('settleStateInit')
    case OrderSettlementState.OSS_PROCESS: //  结算中
      return tl('settleStateProcess')
    case OrderSettlementState.OSS_ABNORMAL: //  结算未知异常
      return tl('settleStateAbnormal')
    case OrderSettlementState.OSS_ABNORMAL_EXCESS: //  结算异常状态，充超额了
      return tl('settleStateAbnormalExcess')
    case OrderSettlementState.OSS_ABNORMAL_BIZ_NON_FINISH_STATE: //  业务不是处于完成状态，无法结算
      return tl('settleStateAbnormalBizNonFinishState')
    case OrderSettlementState.OSS_ABNORMAL_WALLET_LACK_MONEY: //  钱包余额不足
      return tl('settleStateAbnormalWalletLackMoney')
    case OrderSettlementState.OSS_SUCCESS: //  业务正常完成
      return tl('settleStateSuccess')
  }
  return tl('chargeStateProgress')
})

const color = computed(() => {
  return '#5e4eff'
})

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createBlock(_component_el_tooltip, {
    placement: "top",
    content: _unref(statusTips)
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", {
        class: "text-status",
        style: _normalizeStyle({ color: _unref(color) })
      }, _toDisplayString(_unref(statusLabel)), 5)
    ]),
    _: 1
  }, 8, ["content"]))
}
}

})